<template>
  <li class="c-sidebar-nav-divider"></li>
</template>

<script>
export default {
  name: 'CSidebarNavDivider'
}
</script>
